/**
 * Функция определяет является ли значение числом
 * @param value искомое значение
 */
export const isNumeric = (value: unknown): value is number =>
  typeof value === "number" && !isNaN(value);
